















































import Vue from "vue"
import { countryList } from "@/model/service/country/country-service"
import { CutOffTime } from "@/model/entity/cut-off-time/cut-off-time"
import store from "@/vuex/store"

export default Vue.extend({
  components: {},
  props: {
    value: {
      type: Object as () => CutOffTime,
      default: null
    }
  },
  data() {
    return {
      cutOffTime: this.value ? Object.assign(new CutOffTime(), this.value) : new CutOffTime(),
      countryList: countryList,
      hoursOptions: (() => {
        const config = store.state.easyshipConfiguration && store.state.easyshipConfiguration.cutOffTime
        const min: number = (config && config.minimumCutOffHour) || 7
        const max: number = (config && config.maximumCutOffHour) || 20
        return Array.from({ length: max - min + 1 }, (_, i) => {
          const h = i + min
          return { value: h, label: `${String(h).padStart(2, "0")}:00` }
        })
      })(),
      rules: {
        postalCode: [
          {
            max: 9,
            message: `${this.$t("user_administration.max")} 9 ${this.$t("user_administration.chars")}`,
            trigger: ["change", "blur"]
          },
          {
            required: true,
            message: `${this.$t("user_administration.field_is_required")}`
          }
        ],
        country: [
          {
            required: true,
            message: `${this.$t("user_administration.field_is_required")}`
          }
        ],
        hours: [
          {
            required: true,
            type: "number",
            message: `${this.$t("user_administration.field_is_required")}`
          }
        ]
      }
    }
  },
  computed: {
    isEditMode(): boolean {
      return !!(this.value && this.value.id)
    }
  },
  methods: {
    emitValidation() {
      const vm = this as any
      let isInfoFormValid
      vm.$refs.formInfo.validate((valid: boolean) => {
        isInfoFormValid = valid
      })
      this.$emit("validateForm", isInfoFormValid)
    }
  },
  watch: {
    cutOffTime: {
      deep: true,
      handler() {
        this.emitValidation()
        this.$emit("modelChanged", this.cutOffTime)
      }
    }
  },
  created() {
    this.cutOffTime.country = this.$store.state.authenticatedEmployee.office.country
  },
  mounted() {
    this.emitValidation()
  }
})
